import { createAction } from '@reduxjs/toolkit'

export const REFERENCE_LOAD = 'REFERENCE_LOAD'
export const REFERENCE_LOAD_PAGE_DATA = 'REFERENCE_LOAD_PAGE_DATA'
export const REFERENCE_LOAD_AUDIENCE = 'REFERENCE_LOAD_AUDIENCE'
export const REFERENCE_LOAD_EDITOR_DATA = 'REFERENCE_LOAD_EDITOR_DATA'
export const REFERENCE_LOAD_EDITOR_AUDIENCE = 'REFERENCE_LOAD_EDITOR_AUDIENCE'

export const referenceLoad = createAction(REFERENCE_LOAD)
export const referenceLoadPageData = createAction(REFERENCE_LOAD_PAGE_DATA)
export const referenceLoadAudience = createAction(REFERENCE_LOAD_AUDIENCE)
export const referenceLoadEditorData = createAction(REFERENCE_LOAD_EDITOR_DATA)
export const referenceLoadEditorAudience = createAction(REFERENCE_LOAD_EDITOR_AUDIENCE)
